/* eslint-disable no-shadow */
import FooterComponent from "Components/CommonComponents/Footer";
import HeaderComponent from "Components/CommonComponents/Header";
import LogedInHeaderComponent from "Components/CommonComponents/LogedInHeader";
import React from "react";
import { Route } from "react-router-dom";

export default function AppRoute({ component: Component, path, isPrivate, ...props }) {
  return (
    <Route
      path={path}
      render={(props) =>
        isPrivate ? (
          <>
            <LogedInHeaderComponent />
            <Component {...props} />
          </>
        ) : (
          <>
            <HeaderComponent />
            <Component {...props} />
            <FooterComponent />
          </>
        )
      }
      {...props}
    />
  );
}
